import { Keys, Scene, Vector } from "excalibur";
import { gameState, inventoryState, playerState } from "../state/stateManager";
import { goToScene } from "../main";
import { sendAlert } from "../utils";
import { Resources } from "../Resources";
import { Player } from "../player";
import HippyChick from "../actors/characters/hippyChick";

export default class BeeClassMenu extends Scene {
  constructor() {
    super();

    this.active = 0;
    this.sellHoney = false;
    this.selected = false;
    this.selectedItem = null;
    this.cashout = false;
    const player = new Player(33 * 16, 15 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 5;
    this.hippyChick = new HippyChick({ x: 33 * 16, y: 12 * 16 });
    this.hippyChick.z = 4;
    this.hippyChick.cutScene = true;
    this.player.cutScene = true;
    this.items = 4;
  }
  onActivate(engine) {
    Resources.BeeClubMap.addToScene(this);
    this.content = playerState.getContent();
    this.add(this.player);
    this.add(this.hippyChick);
    this.player.cutScene = true;
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.classList.add("commerce");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("feed-menu");

    this.menu.style.display = "block";
    this.drawMenu();
  }
  drawMenu() {
    if (this.active == 0) {
      this.menu.innerHTML = `<h1>Bee Club</h1>
      <p>Enter To Select, X> BACK</p>
        <h1>Class Signup: </h1>
       
        <ul class="beeClassUL">
            <li id="list0"><span id="selector">></span>Beekeeping 101 ${
              this.content.beeClasses.completed.find(
                (item) => item == "beekeeping101"
              )
                ? "*"
                : ""
            }</li>
            <li id="list1">Honey</li>
          <li id="list1">Biology</li><li id="list1">Hive Management</li>
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>Bee Club</h1>
      <p>Enter To Select, X> BACK</p>
        <h1>Class Signup: </h1>
        <ul class="beeClassUL">
            <li id="list0">Beekeeping 101 ${
              this.content.beeClasses.completed.find(
                (item) => item == "beekeeping101"
              )
                ? "*"
                : ""
            }</li>
            <li id="list1"><span id="selector">></span>Honey</li>
          <li id="list1">Biology</li><li id="list1">Hive Management</li>
          </ul>
       
        `;
    } else if (this.active == 2) {
      this.menu.innerHTML = `<h1>Bee Club</h1>
      <p>Enter To Select, X> BACK</p>
        <h1>Class Signup: </h1>
        <ul class="beeClassUL">
            <li id="list0">Beekeeping 101 ${
              this.content.beeClasses.completed.find(
                (item) => item == "beekeeping101"
              )
                ? "*"
                : ""
            }</li>
            <li id="list1">Honey</li>
          <li id="list1"><span id="selector">></span>Biology</li><li id="list1">Hive Management</li>
          </ul>
       
        `;
    } else if (this.active == 3) {
      this.menu.innerHTML = `<h1>Bee Club</h1>
      <p>Enter To Select, X> BACK</p>
        <h1>Class Signup: </h1>
        <ul class="beeClassUL">
            <li id="list0">Beekeeping 101 ${
              this.content.beeClasses.completed.find(
                (item) => item == "beekeeping101"
              )
                ? "*"
                : ""
            }</li>
            <li id="list1">Honey</li>
          <li id="list1">Biology</li><li id="list1"><span id="selector">></span>Hive Management</li>
          </ul>
       
        `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      if (this.active == this.items - 1) {
        this.active = 0;
      } else {
        this.active++;
      }
      if (!this.selected) {
        this.drawMenu();
      } else {
        switch (this.selectedItem) {
          case 0:
            break;
          case 1:
            this.openHoneyClassMenu();
            break;
          case 2:
            this.openBiologyClassMenu();
            break;

          case 3:
            this.openHiveManagementClassMenu();
            break;
          default:
            break;
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.active == 0) {
        this.active = this.items - 1;
      } else {
        this.active = this.active - 1;
      }
      if (!this.selected) {
        this.drawMenu();
      } else {
        switch (this.selectedItem) {
          case 0:
            break;
          case 1:
            this.openHoneyClassMenu();
            break;
          case 2:
            this.openBiologyClassMenu();
            break;

          case 3:
            this.openHiveManagementClassMenu();
            break;
          default:
            break;
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      let content = playerState.getContent();

      if (!this.selected) {
        switch (this.active) {
          case 0:
            //sign up for beekeeping 101

            content.beeClasses.signedUp = "beekeeping101";
            sendAlert("Signed Up For Beekeeping 101!");
            this.selected = false;
            this.active = 0;
            this.drawMenu();
            break;
          case 1:
            //open honey class menu
            this.selected = true;
            this.selectedItem = 1;
            this.items = content.beeClasses.classes.honeyClasses.length;
            this.active = 0;
            this.openHoneyClassMenu();
            break;
          case 2:
            //open biology class menu
            this.selected = true;
            this.selectedItem = 2;
            this.items = content.beeClasses.classes.biologyClasses.length;
            this.active = 0;
            this.items = 6;
            this.openBiologyClassMenu();
            break;
          case 3:
            //open hive management class menu
            this.selected = true;
            this.selectedItem = 3;
            this.items =
              content.beeClasses.classes.hiveManagementClasses.length;
            this.active = 0;
            this.items = 5;
            this.openHiveManagementClassMenu();
            break;
          default:
            break;
        }
      } else {
        switch (this.selectedItem) {
          case 0:
            break;
          case 1:
            //sign up for correct honey class
            content.beeClasses.signedUp =
              content.beeClasses.classes.honeyClasses[this.active].id;

            sendAlert(
              `Signed Up For ${
                content.beeClasses.classes.honeyClasses[this.active].name
              }`
            );
            this.selected = false;
            this.active = 0;
            this.drawMenu();
            break;
          case 2:
            //biology class
            content.beeClasses.signedUp =
              content.beeClasses.classes.biologyClasses[this.active].id;
            console.log(
              "class: ",
              content.beeClasses.classes.biologyClasses[this.active]
            );
            sendAlert(
              `Signed Up For ${
                content.beeClasses.classes.biologyClasses[this.active].name
              }`
            );
            this.selected = false;
            this.active = 0;
            this.drawMenu();
            break;
          case 3:
            //management class
            content.beeClasses.signedUp =
              content.beeClasses.classes.hiveManagementClasses[this.active].id;

            sendAlert(
              `Signed Up For ${
                content.beeClasses.classes.hiveManagementClasses[this.active]
                  .name
              }`
            );
            this.selected = false;
            this.active = 0;
            this.drawMenu();
            break;
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected) {
        this.drawMenu();
        this.selected = false;
        this.active = 0;
        this.items = 4;
      } else {
        this.player.cutScene = false;
        this.active = 0;
        this.selected = false;
        this.items = 4;
        goToScene("beeClub");
      }
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.menuContainer.classList.remove("commerce");
  }
  openHoneyClassMenu() {
    this.menu.innerHTML = `<h1>Bee Club</h1>
    <p>Enter To Select, X> BACK</p>
    <h1>Honey</h1>
    <ul>${this.content.beeClasses.classes.honeyClasses
      .map((id, k) => {
        return `<li>${k == this.active ? `<span id="selector">></span>` : ""}${
          id.name
        } ${
          this.content.beeClasses.completed.find((item) => item == id.id)
            ? "*"
            : ""
        }</li>`;
      })
      .join("")}</ul>`;
  }
  openBiologyClassMenu() {
    this.menu.innerHTML = `<h1>Bee Club</h1>
    <p>Enter To Select, X> BACK</p>
    <h1>Biology</h1>
    <ul>${this.content.beeClasses.classes.biologyClasses
      .map((id, k) => {
        return `<li>${k == this.active ? `<span id="selector">></span>` : ""}${
          id.name
        }${
          this.content.beeClasses.completed.find((item) => item == id.id)
            ? "*"
            : ""
        }</li>`;
      })
      .join("")}</ul>`;
  }
  openHiveManagementClassMenu() {
    this.menu.innerHTML = `<h1>Bee Club</h1>
    <p>Enter To Select, X> BACK</p>
    <h1>Hive Management</h1>
    <ul>${this.content.beeClasses.classes.hiveManagementClasses
      .map((id, k) => {
        return `<li>${k == this.active ? `<span id="selector">></span>` : ""}${
          id.name
        }${
          this.content.beeClasses.completed.find((item) => item == id.id)
            ? "*"
            : ""
        }</li>`;
      })
      .join("")}</ul>`;
  }
}
